<template>
    <div>
        <v-layout row wrap xs12>
            <h3>Frères & Sœurs :</h3>
            <!-- debut dialog -->
            <v-dialog v-model="dialog" max-width="60%">
                <template v-slot:activator="{ on }">
                    <v-layout align-start justify-end>
                        <v-btn style="min-width: 0; margin-bottom:0; margin-top:0"
                               color="primary"
                               small
                               dark
                               v-on="on">
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Add' : 'Ajouter'}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-card>
                    <v-toolbar color="cyan darken-4" dark>
                        <v-toolbar-title>{{$storeCandidature.langueFormulaire == 'en' ? 'Add brother or sister' : 'Ajouter frère ou soeur'}}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout row wrap xs12>
                                <v-flex xs4>
                                    <v-text-field :counter="30" v-model="editedItem.Prenom" :label="$storeCandidature.langueFormulaire == 'en' ? 'First name' : 'Prenom'"></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field :counter="30" v-model="editedItem.Nom" :label="$storeCandidature.langueFormulaire == 'en' ? 'Last name' : 'Nom'"></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field number :counter="3" v-model="editedItem.Age" label="Age"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap xs12>
                                <v-flex xs4>
                                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.SexeList"
                                                    v-model="editedItem.Sexe"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Gender' : 'Sexe'"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field :counter="30"
                                                  v-model="editedItem.SituationScolPro"
                                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'School / professional situation' : 'Situation scolaire / professionnelle'">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field :counter="30"
                                                  v-model="editedItem.EtablissementEntreprise"
                                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution / Company' : 'Etablissement / Entreprise'">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap xs12 pl-3>
                                <v-flex xs4>
                                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'alumnus' : 'Ancien élève'" v-model="editedItem.AncienEleve"></v-switch>
                                </v-flex>
                                <v-flex xs4 pl-3>
                                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Student INSEEC Group' : 'Elève Groupe INSEEC'"
                                              v-model="editedItem.EleveGroupInseec">
                                    </v-switch>
                                </v-flex>
                                <v-flex xs4>
                                    <v-autocomplete class="pt-0" v-if="editedItem.EleveGroupInseec"
                                                    :items="$storeCandidature.etablissementInseecList"
                                                    v-model="editedItem.QuelEtablissement"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Which institution?': 'Quel établissement ?'"
                                                    item-text="Label"
                                                    item-value="Id"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">{{$storeCandidature.langueFormulaire == 'en' ? 'Cancel' : 'Annuler'}}</v-btn>
                        <v-btn color="blue darken-1" flat @click="save">{{$storeCandidature.langueFormulaire == 'en' ? 'Validate' : 'Valider'}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- fin dialog -->
            <hr size="5" width="100%" color="secondary">
        </v-layout>
        <!-- Début frères et soeurs -->
        <v-data-table :headers="headers" :items="$storeCandidature.sasCandidature.ListeFreresSoeurs" class="elevation-1" disable-pagination hide-default-footer>
            <template v-slot:no-data>
                <v-alert :value="true" color="grey lighten-3" icon="warning">{{$storeCandidature.langueFormulaire == 'en' ? 'List empty' : 'La liste est vide'}}</v-alert>
            </template>
            <template v-slot:item={item}>
                <tr v-if="!item.Supprimer">
                    <th class="text-xs-left">{{ item.Prenom }}</th>
                    <th class="text-xs-left">{{ item.Nom }}</th>
                    <th class="text-xs-center">{{ item.Age }}</th>
                    <th class="text-xs-left">{{ item.Sexe? ($storeCandidature.langueFormulaire == 'en' ? item.Sexe.Lang01 : item.Sexe.Lang00) : '' }}</th>
                    <th class="text-xs-left">{{ item.SituationScolPro }}</th>
                    <th class="text-xs-left">{{ item.EtablissementEntreprise }}</th>
                    <th>
                        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                        <v-icon small @click="deleteItem(item)">delete</v-icon>
                    </th>
                </tr>
            </template>
        </v-data-table>
        <!-- fin liste frères ets soeurs-->
    </div>
</template>
<script>
    export default {
        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,

                // Dialig et Header list
                dialog: false,
                headers: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'First name' : 'Prénom', value: 'prenom' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Last name' : 'Nom', value: 'nom' },
                    { text: 'Age', value: 'age' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Gender' : 'Sexe', value: 'sexe' },
                    { text: 'Situation', value: 'situation' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: '', value: 'actions', sortable: false }
                ],

                editedIndex: -1,
                editedItem: {
                    Nom: '',
                    Age: '',
                    Sexe: null,
                    SituationScolPro: '',
                    EtablissementEntreprise: '',
                    AncienEleve: false,
                    EleveGroupInseec: false,
                    QuelEtablissement: '',
                    Supprimer: false
                },
            }
        },

        methods: {
            editItem(item) {
                this.editedIndex = this.$storeCandidature.sasCandidature.ListeFreresSoeurs.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {
                if (confirm(this.$storeCandidature.langueFormulaire == 'en' ? 'Are you sure you want to delete' : 'Etes-vous sûr de vouloir supprimer ' + item.Prenom + '?')) {
                    this.editedIndex = this.$storeCandidature.sasCandidature.ListeFreresSoeurs.indexOf(item)
                    this.editedItem.Supprimer = true;
                    Object.assign(this.$storeCandidature.sasCandidature.ListeFreresSoeurs[this.editedIndex], this.editedItem)
                    this.$storeCandidature.candidatureChanged = true
                }
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, {
                        Nom: '',
                        Age: '',
                        Sexe: null,
                        SituationScolPro: '',
                        EtablissementEntreprise: '',
                        AncienEleve: false,
                        EleveGroupInseec: false,
                        QuelEtablissement: '',
                        Supprimer: false
                    })
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                if (this.editedIndex > -1) {
                    Object.assign(this.$storeCandidature.sasCandidature.ListeFreresSoeurs[this.editedIndex], this.editedItem)
                } else {
                    this.$storeCandidature.sasCandidature.ListeFreresSoeurs.push(this.editedItem)
                }
                this.$storeCandidature.candidatureChanged = true
                this.close()                
            },
        },
    }
</script>

